import { render, staticRenderFns } from "./GERAL_APP_URL_VERSOCHAT.vue?vue&type=template&id=45c5c8d1&scoped=true"
import script from "./GERAL_APP_URL_VERSOCHAT.vue?vue&type=script&lang=js"
export * from "./GERAL_APP_URL_VERSOCHAT.vue?vue&type=script&lang=js"
import style0 from "./GERAL_APP_URL_VERSOCHAT.vue?vue&type=style&index=0&id=45c5c8d1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c5c8d1",
  null
  
)

export default component.exports